import moment, { Moment } from "moment";

export type DATE_FORMAT =
  | "DD/MM/YYYY"
  | "DD/MM/YYYY HH:ss:mm"
  | "DD-MM-YYYYTHH:ss:mm"
  | string;

export const formatDate = (
  date: string,
  format: DATE_FORMAT = "DD/MM/YYYY"
): string => {
  return moment(date).format(format);
};

export const formatMomentToDate = (
  moment: moment.Moment,
  format: DATE_FORMAT = "DD/MM/YYYY"
): string => {
  return moment.format(format);
};

export const startOfWeek = (format: DATE_FORMAT = "DD/MM/YYYY") => {
  return moment().startOf("week").format(format);
};
export const endOfWeek = (format: DATE_FORMAT = "DD/MM/YYYY") => {
  return moment().endOf("week").format(format);
};

export const viInstallation = () => {
  return moment.updateLocale("vi", {
    months:
      "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
        "_"
      ),
    monthsShort:
      "Thg 1_Thg 2_Thg 3_Thg 4_Thg 5_Thg 6_Thg 7_Thg 8_Thg 9_Thg 10_Thg 11_Thg 12".split(
        "_"
      ),
    monthsParseExact: true,
    weekdays: "Chủ nhật_Thứ hai_Thứ ba_Thứ tư_Thứ năm_Thứ sáu_Thứ bảy".split(
      "_"
    ),
    weekdaysShort: "CN_Hai_Ba_Tư_Năm_Sáu_Bảy".split("_"),
    weekdaysMin: "CN_Hai_Ba_Tư_Năm_Sáu_Bảy".split("_"),
    weekdaysParseExact: true,
    meridiemParse: /sa|ch/i,
    isPM: function (input) {
      return /^ch$/i.test(input);
    },
    meridiem: function (hours, minutes, isLower) {
      if (hours < 12) {
        return isLower ? "sa" : "SA";
      } else {
        return isLower ? "ch" : "CH";
      }
    },
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM [năm] YYYY",
      LLL: "D MMMM [năm] YYYY HH:mm",
      LLLL: "dddd, D MMMM [năm] YYYY HH:mm",
      l: "DD/M/YYYY",
      ll: "D MMM YYYY",
      lll: "D MMM YYYY HH:mm",
      llll: "ddd, D MMM YYYY HH:mm",
    },
    calendar: {
      sameDay: "[Hôm nay lúc] LT",
      nextDay: "[Ngày mai lúc] LT",
      nextWeek: "dddd [tuần tới lúc] LT",
      lastDay: "[Hôm qua lúc] LT",
      lastWeek: "dddd [tuần trước lúc] LT",
      sameElse: "L",
    },
    relativeTime: {
      future: "%s tới",
      past: "%s trước",
      s: "vài giây",
      ss: "%d giây",
      m: "một phút",
      mm: "%d phút",
      h: "một giờ",
      hh: "%d giờ",
      d: "một ngày",
      dd: "%d ngày",
      w: "một tuần",
      ww: "%d tuần",
      M: "một tháng",
      MM: "%d tháng",
      y: "một năm",
      yy: "%d năm",
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal: function (number: any) {
      return number;
    },
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  });
};
